import { HdsPage } from '/react4xp/pages/hds-page/hds-page'

export default (props) => <HdsPage {...props} />
